import FacetItem from './FacetItem.js';
export default FacetItem;
